import { axios } from '@Root/API'

export const getUserOptions = () => {
	return axios.get('users')
}
